import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}zortout`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const zortoutApi = {
  getZortout: (request) => {
    const { data } = request
    const { pageid, ...rest } = data
    return instance().get(`/${pageid}/config`, rest)
  },
  getZortoutToken: (request) => {
    const { data } = request
    const { pageid, ...rest } = data
    return instance().get(`/${pageid}/generate-api-token`, rest)
  },
  putZortout: (request) => {
    const { data } = request
    const { pageid, ...rest } = data
    return instance().put(`/${pageid}/config`, rest.body)
  }
}

export default zortoutApi



// WEBPACK FOOTER //
// ./src/api/zortout.js